$('.welcome__button').on('click', function () {
    $(this).toggleClass('open');
    $(this).closest('.welcome').find('.welcome__toogle-block').slideToggle();
});